<template>
  <v-container
    grid-list-xl
    fluid
  >
    <v-layout
      row
      wrap
    >
      <v-flex
        xs12
      >
        <v-data-table
          v-model="selected"
          :loading="loading"
          :headers="headers"
          :items="collection"
          :total-items="meta.totalItems"
          :rows-per-page-text="$t('Rows per page')"
          :rows-per-page-items="meta.rowsPerPageItems"
          :pagination.sync="pagination"
          class="elevation-1"
          item-key="id"
        >
          <v-progress-linear
            slot="progress"
            color="primary"
            indeterminate
          />

          <template v-slot:items="props">
            <UserDataTableRow
              :props="props"
            />
          </template>
          <template v-slot:pageText="props">
            <span>{{ $t('{0} - {1} of {2}', [props.pageStart, props.pageStop, props.itemsLength]) }}</span>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import UserDataTableRow from '../../components/UserDataTableRow'
import MassActionSelect from '../../../../vuetify-console/components/MassActionSelect'

import { createNamespacedHelpers } from 'vuex'
const { mapActions, mapGetters } = createNamespacedHelpers('authentication/users')

export default {
  name: 'UserList',

  components: {
    UserDataTableRow,
    MassActionSelect
  },

  actionBar () {
    return {
      title: 'Users',
      actions: [
        {
          text: 'Add New User',
          event: 'add'
        }
      ]
    }
  },

  data () {
    return {
      selected: []
    }
  },

  computed: {
    ...mapGetters(['collection', 'loading', 'meta']),

    pagination: {
      get: function () {
        return this.meta
      },
      set: function (value) {
        this.applyMeta(value)
      }
    },

    headers () {
      return [
        { text: this.$t('Name'), value: 'name' },
        { text: this.$t('Email'), value: 'email' },
        { text: this.$t('Type'), value: 'type' },
        { text: this.$t('Created At'), value: 'created_at' }
      ]
    }
  },

  methods: {
    ...mapActions(['applyMeta', 'fetchCollection', 'removeFilter', 'clearFilters']),

    onActionAdd () {
      this.$router.push({ name: 'single_user', params: { id: '__' } })
    }
  }
}
</script>
